import $ from 'jquery';

/**
 * Handle password visibility button
 *
 * @type {DynamicInitFunction<HTMLElement>}
 */
export default ($collection) => {

	for (const toggleButton of $collection) {

		const $toggleButton = $(toggleButton);
		const $input = $toggleButton.parent().find('input');
		// Make sure the toggle button is the last child
		$toggleButton.appendTo($toggleButton.parent());

		$toggleButton.on('click.toggle-password', () => {
			if (toggleButton.dataset.togglePassword === 'false') {
				toggleButton.dataset.togglePassword = 'true';
				$input.attr('type', 'text');
				$toggleButton.addClass('show-password');
				mpro.replaceIcon($toggleButton.find('.mdi'), 'password_off');
			}
			else {
				toggleButton.dataset.togglePassword = 'false';
				$input.attr('type', 'password');
				$toggleButton.removeClass('show-password');
				mpro.replaceIcon($toggleButton.find('.mdi'), 'password_on');
			}
		});
	}
};